export const resolvePageComponent =  (regionTID, pageTID) => {
  switch (regionTID) {
    case '72':
    case '29':
      return () => import(`./app2025/pages/${pageTID}.vue`);
      // row bellow for new design 2026
    case '59':
    case '54':
    case '75':
    case '66':
    case '63':
    case '74':
      return () => import(`./app2026/pages/${pageTID}.vue`);
    default:
  }

  return () => import(`./app2024/pages/${pageTID}.vue`);
}

export const resolveAppComponent = (regionTID) => {
  switch (regionTID) {
    case '72':
    case '29':
      return () => import('./app2025/App.vue');
      // row bellow for new design 2026
    case '59':
    case '54':
    case '75':
    case '66':
    case '63':
    case '74':
      return () => import('./app2026/App.vue');
    default:
  }

  return () => import('./app2024/App.vue');
}



// WEBPACK FOOTER //
// ./src/resolve.js